import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Asset } from '@app/core/model/entities/asset/asset';
import {
  OrganizationLeaseCreateModalComponent
} from '@app/features/main/views/organization-occupants/modals/organization-lease-create-modal/organization-lease-create-modal.component';

@Component({
  templateUrl: './lease-create-modal.component.html',
  styleUrls: [
    '../../../../../../../../shared/components/form-builder/sections/create-modal.component.scss',
    '../../../../../organization-occupants/modals/organization-lease-create-modal/organization-lease-create-modal.component.scss'
  ],
  standalone: false
})
export class LeaseCreateModalComponent extends OrganizationLeaseCreateModalComponent implements OnInit {
  private asset = inject<{ asset: Asset }>(MAT_DIALOG_DATA).asset;

  /**
   * Set initial Asset value so Spaces can be loaded.
   */
  public ngOnInit(): void {
    super.ngOnInit();
    this.leaseForm.controls.asset.setValue(this.asset.toRelatedAsset());
  }
}
